import { POSTHOG_SCHEMA_VERSION } from '@/lib/posthogIdentity';
import { trackEvent } from '@/lib/trackEvent';
import type { ReportSaveTriggerSource } from '@/types/reports';

const SESSION_KEY_PREFIX = 'ph_report_updated:';

const getSessionKey = (reportId: string, triggerSource: ReportSaveTriggerSource) =>
  `${SESSION_KEY_PREFIX}${reportId}:${triggerSource}`;

export const trackReportUpdated = (
  reportId?: string | null,
  triggerSource: ReportSaveTriggerSource = 'save_button'
): boolean => {
  if (!reportId) return false;
  if (typeof sessionStorage === 'undefined') return false;
  if (sessionStorage.getItem(getSessionKey(reportId, triggerSource)) === '1') {
    return false;
  }

  const tracked = trackEvent('report_updated', {
    report_id: reportId,
    schema_version: POSTHOG_SCHEMA_VERSION,
    trigger_source: triggerSource,
  });

  if (tracked) {
    sessionStorage.setItem(getSessionKey(reportId, triggerSource), '1');
  }

  return tracked;
};
